import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import * as IFrameActions from '../../../store/actions/iFrameSource';
import CustomIframe from '../../iframe/iframe';


const T = Translator.create();
let _common: Common;
const _logger = Log.create('Add Class');

export class CAddClass extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public state: any = {
        row4status: false,
        isModalOpen: false,
    };

    componentDidMount(): void {
        let model = {
            CourseId: this.props.courseId,
            ClassId: this.props.classId,
            ReturnUrl: '/Class/New/{2}?refClassId={1}'
        }
        this.props.dispatch(IFrameActions.getIFrameSource(model));
    }

    triggerModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    };

    handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.setState((prevState: { row4status: any; }) => ({
            row4status: !prevState.row4status,
          }));
        }
      };
    public render() {
        return (
            <>
                <Collapse isOpen={this.state.row4status}>
                    <div className="row report-row-expanded">
                        <div className="col-12 page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                            <div>
                                <CustomIframe
                                    id='previewAddingClass'
                                    name='previewAddingClass'
                                    width={'100%'}
                                    height={'100%'}
                                    src={this.props.iFrameSource}
                                />
                            </div>
                        </div>
                    </div>
                </Collapse>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }

    const newProps: any = Object.assign({}, ownProps, {
        iFrameSource: state.iFrame.iFrameSource
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks;
    return ret;
};

const AddClass = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(CAddClass);

export default AddClass;
